import { render, staticRenderFns } from "./ProfileWidget.vue?vue&type=template&id=2d9964ed&scoped=true"
import script from "./ProfileWidget.vue?vue&type=script&lang=js"
export * from "./ProfileWidget.vue?vue&type=script&lang=js"
import style0 from "./ProfileWidget.vue?vue&type=style&index=0&id=2d9964ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9964ed",
  null
  
)

export default component.exports